export default __webpack_public_path__ + "static/media/checked.e2b43cdb.svg";